import { TrackingPageModel } from '../tracking-page.model';
import { getAsset, getProductItems } from './helpers';
import {
  getFontConfig,
  getImage,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white
} from './helpers';

export const empire: TrackingPageModel = {
  languageMenu: getLanguageMenu('Cabin', white),
  searchPageInput: {
    backgroundColor: white,
    shadow: 'none',
    borderColor: '#ced4da',
    borderWidth: 1,
    borderRadius: 4,
    ...getFontConfig('Cabin', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Cabin', '#4d4d4dff')
  },
  background: {
    color: white,
    useBackgroundImage: false,
    imageUrl: getImage('/assets/img/tracking-page/Img_map_white.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    linksColor: '#1e8570ff',
    linksUnderline: true,
    backgroundColor: white,
    headerBackground: white,
    footerBackground: white,
    borderColor: '#4d4d4d33',
    borderRadius: 3,
    borderWidth: 1,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Cabin', '#4d4d4dff')
  },
  orderCard: {
    borderRadius: 3,
    borderWidth: 1,
    borderColor: '#4d4d4d33',
    backgroundColor: white,
    shadow: 'none',
    footerBackground: white,
    headerBackground: white,
    linksColor: '#1e8570ff',
    linksUnderline: true,
    ...getFontConfig('Cabin', '#4d4d4dff')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 20,
    ...getFontConfig('Cabin', '#4d4d4dff')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 20,
    ...getFontConfig('Cabin', '#4d4d4dff')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Cabin', '#b7b7b7ff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 14,
    ...getFontConfig('Cabin', '#c83939ff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    shadow: 'none',
    borderColor: '#4d4d4d33',
    borderRadius: 3,
    borderWidth: 1,
    backgroundColor: '#ffffff',
    button: {
      on: true,
      backgroundColor: '#ffffff',
      borderColor: '#2E4068',
      borderRadius: 3,
      borderWidth: 1,
      shadow: 'none',
      ...getFontConfig('Cabin', '#000000')
    },
    itemsLimit: 4,
    scroll: false,
    itemCard: {
      backgroundColor: '#ffffff00',
      borderColor: '#ffffff33',
      borderRadius: 0,
      borderWidth: 1,
      shadow: 'none',
      title: {
        alignment: 'center',
        fontSize: 18,
        ...getFontConfig('Cabin', '#4d4d4dff')
      },
      info: {
        alignment: 'center',
        fontSize: 14,
        ...getFontConfig('Cabin', '#4d4d4dff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#ffffff00',
    borderColor: white,
    borderRadius: 3,
    borderWidth: 2,
    shadow: 'none',
    ...getFontConfig('Cabin', white)
  },
  detailsButton: {
    on: null,
    backgroundColor: '#ffb354ff',
    borderColor: '#528ec1ff',
    borderRadius: 3,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Cabin', '#1a390cff')
  },
  trackButton: {
    on: null,
    backgroundColor: '#ffb354ff',
    borderColor: '#ee7227',
    borderRadius: 3,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Cabin', '#1a390cff')
  },
  pageScroll: {
    scrollColor: '#0000003d',
    borderRadius: 4,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(
    getAsset('/images/themes/5c98efb34787e_empiresupplylogo-306x114.png')
  ),
  socialIcons: getSocialIcons(white),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: white,
    borderColor: '#4d4d4d33',
    borderRadius: 3,
    borderWidth: 1,
    sidebarField: 'orderNumbers',
    shadow: 'none',
    ...getFontConfig('Cabin', '#4d4d4dff')
  },
  footer: {
    linksColor: '#1e8570ff',
    linksUnderline: true,
    backgroundColor: white,
    ...getFooterItems(),
    ...getFontConfig('Cabin', '#4d4d4dff')
  },
  header: {
    backgroundColor: '#30656bff'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#4d4d4d33',
    borderRadius: 3,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#4d4d4d33',
      borderRadius: 3,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#ffb354ff',
        borderColor: '#528ec1ff',
        borderRadius: 3,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Cabin', '#1a390cff')
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 11,
        ...getFontConfig('Cabin', '#4d4d4dff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Cabin', '#4d4d4dff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 12,
        ...getFontConfig('Cabin', '#4d4d4dff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('sidebar'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#ffb354ff',
      arrowSize: 24
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#4d4d4d33',
    borderRadius: 3,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#4d4d4d33',
      borderRadius: 3,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#ffb354ff',
        borderColor: '#528ec1ff',
        borderRadius: 3,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Cabin', '#1a390cff')
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 11,
        ...getFontConfig('Cabin', '#4d4d4dff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Cabin', '#4d4d4dff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 12,
        ...getFontConfig('Cabin', '#4d4d4dff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('main'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#ffb354ff',
      arrowSize: 24
    }
  },
  seoTitle: ''
};
